import { createContext, useState, useContext, useEffect,ReactNode } from 'react';
import { auth } from '../../Environment/firebase';
import { db } from '../../Environment/firebase';
import { setDatabaseData } from '../../Functions/APIservice/useDatabase';
import { NetworkError } from '../../Pages/Error/NetworkError';
import firebase from "firebase/compat/app";



export type UserDataType = {
  uid: string,
  nickname: string | null,
  position: string,
  belongs: string,
  provider: string,
  displayName: string,
  photoURL: string,
  email: string,
  agree: boolean,
  grade: number,
  prefecture:number,
  department: number,
  magazine: boolean,
  media:any[],
  userStatus: string,
  createTime: firebase.firestore.FieldValue,
  changeTime: firebase.firestore.FieldValue
}

type AuthContextType = {
  user:firebase.User | null,
  loading:boolean,
  userData:UserDataType | null,
  userDataId:string | null,
  userExist:boolean,
  agree:boolean
}




const AuthContext = createContext<AuthContextType>(
    { user:null,
    loading:true,
    userData:null,
    userDataId:null,
    userExist:false,
    agree:false });


export function useAuthContext(): AuthContextType {
  return useContext(AuthContext);
}

export function AuthProvider({ children }: {children: ReactNode }) {

  const [user, setUser] = useState<firebase.User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [userData, setUserData] = useState<UserDataType  | null>(null);
  const [userDataId, setUserDataId] = useState<string | null>(null);
  const [agree, setAgree] = useState<boolean>(false);
  const [userExist,setUserExist] = useState<boolean>(false);
  const [offline,setOffline] = useState<boolean>(false);


  const value = {
    user,
    loading,
    userData,
    userDataId,
    userExist,
    agree,
  };

  useEffect(() => {
    const unsubscribed = auth.onAuthStateChanged(async(user) => {
      setUser(user);

      if (user) {
        await db.collection("users")
            .doc(user.uid)
            .get()
            .then((doc) => {
              if (doc.exists) {
                const docData = doc.data()
                setUserExist(true);
                setUserDataId(doc.id);
                
                // doc.data() is never undefined for query doc snapshots
                if(docData){
                    setAgree(docData.agree || false);
                    setUserData({
                      uid: docData.uid,
                      nickname: docData.nickname,
                      position: docData.position,
                      belongs: docData.belongs,
                      provider:docData.provider,
                      displayName: docData.displayName,
                      photoURL: docData.photoURL,
                      email: docData.email,
                      agree:docData.agree,
                      grade: docData.grade,
                      prefecture:docData.prefecture,
                      department: docData.department,
                      magazine: docData.magazine,
                      media:docData.media,
                      userStatus: docData.userStatus,
                      createTime: docData.createTime,
                      changeTime: docData.changeTime,
                    })
                    if (user.displayName !== docData.displayName ||
                        user.photoURL !== docData.photoURL) {
                        setDatabaseData(
                            "users",
                            doc.id,
                            {
                            displayName: user.displayName,
                            photoURL: user.photoURL,
                            uid:user.uid
                            }
                        )
                    };
                    //最後にアクセスした日を記録
                    let createDate
                    if (typeof docData.changeTime === 'undefined') {
                        createDate = new Date(docData.createTime.seconds * 1000 + docData.createTime.nanoseconds / 1000)      
                    } else {
                        createDate = new Date(docData.changeTime.seconds * 1000 + docData.changeTime.nanoseconds / 1000)   
                    }
                    var createDateMonth = createDate.getMonth()
                    let createDateYear
                    //自動で学年を更新
                    if (createDateMonth < 3) {
                        createDateYear = createDate.getFullYear() - 1
                    } else {
                        createDateYear = createDate.getFullYear()
                    }
                    var passedGrade:number = new Date().getTime() - new Date(createDateYear, 3, 1).getTime(); //登録した学年からの経過ミリ秒を取得

                    passedGrade = parseInt((passedGrade / (1000 * 60 * 60 * 24 * 365)).toString())//ミリ秒を年に直す。
                    setDatabaseData(
                      "users",
                      doc.id,
                      {
                        grade:Math.min(6, docData.grade + passedGrade),
                        changeTime: firebase.firestore.FieldValue.serverTimestamp(),
                        uid:user.uid
                      }
                    )
                }                
                setLoading(false);            
            } else {
              setLoading(false);
              console.log('データは0件です')
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log("Error getting documents: ", error);
            if(String(error).includes('the client is offline')){
              setOffline(true);
            }
          });
      } else {
        setLoading(false);
      }
    });
    return () => {
      unsubscribed();
    };
  }, []);

  if (loading === true) {
    return <AuthContext.Provider value={value}>{<div><h3>Loading...</h3></div>}</AuthContext.Provider>;
  } else {
    if(offline === true){
      return <AuthContext.Provider value={value}>{!loading && <NetworkError></NetworkError>}</AuthContext.Provider>;
    }else{
      return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
    }
    
  }
}
